import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavLink } from 'core/types/nav-link';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SidenavState } from 'shared/modules/skeleton/main-layout/sidenav-state';

const COMPACT_LAYOUT_QUERY = '(max-width: 600px)';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MainLayoutComponent {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  @Input() navLinks = new Array<NavLink>();

  private sidenavStore = new SidenavState();

  readonly isCompact = this.breakpointObserver.observe(COMPACT_LAYOUT_QUERY).pipe(map(result => result.matches));
  compactSidenavOpen = false;

  constructor(private breakpointObserver: BreakpointObserver) {}

  get isSidenavOpen(): Observable<boolean> {
    return this.sidenavStore.isOpen;
  }

  get isSidenavOverlapped(): Observable<boolean> {
    return this.sidenavStore.isOverlapped;
  }

  toggleSidenavOpenState(): void {
    if (this.breakpointObserver.isMatched(COMPACT_LAYOUT_QUERY)) {
      this.compactSidenavOpen = !this.compactSidenavOpen;
      return;
    }

    this.sidenav.toggle()
      .then((state) => {
        if (!this.breakpointObserver.isMatched(COMPACT_LAYOUT_QUERY)) {
          this.sidenavStore.toggleOpenState(state === 'open');
        }
      });
  }

  onSidenavOpenChange(isOpen: boolean): void {
    if (this.breakpointObserver.isMatched(COMPACT_LAYOUT_QUERY) && !isOpen && !this.sidenav.opened) {
      this.compactSidenavOpen = false;
    }
  }

  closeCompactSidenav(): void {
    if (this.breakpointObserver.isMatched(COMPACT_LAYOUT_QUERY)) {
      this.compactSidenavOpen = false;
    }
  }

  toggleOverlappedState(event: MouseEvent): void {
    event.preventDefault();
    this.sidenavStore.toggleOverlapState();
  }
}
